import { render } from "./ControleDeColaborador.vue?vue&type=template&id=b672c454"
import script from "./ControleDeColaborador.vue?vue&type=script&lang=js"
export * from "./ControleDeColaborador.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__